import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import Isvg from 'react-inlinesvg';
import Swipe from 'react-easy-swipe';
import { intlShape, intlMessage } from 'constants/propTypes';
import { ICONS } from 'constants/icons';
import { SvgArrow } from 'components/Svgs';
import './ImageCarousel.scss';

class ImageCarousel extends React.Component {
  // this complains no matter where you put it
  // eslint-disable-next-line react/sort-comp
  static modalConfig = {
    overlayClassName: 'image-carousel__overlay',
    className: 'image-carousel__content',
  };

  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        mediaUrl: PropTypes.string,
        mediaId: PropTypes.number,
        alt: PropTypes.string,
      })
    ),
    intl: intlShape,
    imageUrl: PropTypes.string,
    initialItemIndex: PropTypes.number,
    closeModal: PropTypes.func,
    alt: intlMessage,
    isMobile: PropTypes.bool,
  };

  static defaultProps = {
    items: [],
    initialItemIndex: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      currentItemIndex: props.initialItemIndex,
    };
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleKeyup);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleKeyup);
  }

  handleKeyup = evt => {
    if (evt.key === 'ArrowLeft') {
      this.handleNavigateLeft();
    } else if (evt.key === 'ArrowRight') {
      this.handleNavigateRight();
    }
  };

  canNavigateRight = () => {
    const { items } = this.props;
    const { currentItemIndex } = this.state;

    return currentItemIndex < items.length - 1;
  };

  canNavigateLeft = () => {
    const { currentItemIndex } = this.state;
    return currentItemIndex > 0;
  };

  handleNavigateLeft = () => {
    if (!this.canNavigateLeft()) return;

    const { currentItemIndex } = this.state;

    this.setState({
      currentItemIndex: currentItemIndex - 1,
    });
  };

  handleNavigateRight = () => {
    if (!this.canNavigateRight()) return null;

    const { currentItemIndex } = this.state;

    this.setState({
      currentItemIndex: currentItemIndex + 1,
    });
  };

  renderLeftArrow = () => {
    if (!this.canNavigateLeft() || this.props.isMobile) return null;

    return (
      <button
        type="button"
        className="image-carousel__arrow image-carousel__arrow--left"
        onClick={this.handleNavigateLeft}>
        <SvgArrow theme="light" className="image-carousel__arrow-icon" direction="left" />
      </button>
    );
  };

  renderRightArrow = () => {
    if (!this.canNavigateRight() || this.props.isMobile) return null;
    return (
      <button
        type="button"
        className="image-carousel__arrow image-carousel__arrow--right"
        onClick={this.handleNavigateRight}>
        <SvgArrow theme="light" className="image-carousel__arrow-icon" direction="right" />
      </button>
    );
  };

  renderCloseButton = () => {
    const { closeModal } = this.props;
    return (
      <button className="image-carousel__close-button" type="button" onClick={closeModal}>
        <Isvg src={ICONS.cross} />
      </button>
    );
  };

  render() {
    const { items, alt, imageUrl, intl } = this.props;
    const { currentItemIndex } = this.state;

    if (imageUrl) {
      return (
        <div className="image-carousel">
          {this.renderCloseButton()}
          <img src={imageUrl} alt={alt && intl.formatMessage(alt)} className="image-carousel__image" />
        </div>
      );
    }

    if (_isEmpty(items)) return null;

    const currentItem = items[currentItemIndex];
    return (
      <div className="image-carousel">
        {this.renderLeftArrow()}
        {this.renderCloseButton()}
        <Swipe onSwipeLeft={this.handleNavigateRight} onSwipeRight={this.handleNavigateLeft}>
          <img src={currentItem.mediaUrl} alt={currentItem.alt} className="image-carousel__image" />
        </Swipe>
        {this.renderRightArrow()}
      </div>
    );
  }
}

export default ImageCarousel;
